import React from 'react'
import { snakeCaseToTitleCase } from 'utils/common'

export const mapNotificationSettings = (permissions = {}, permissionsId, color = 'accent0') => {
  let mappedPermissions = []

  const buildInput = (item, key) => {
    const buildId = `${item.domain}---${item.action}---${key}`
    return { 
      width: 70, 
      className: key === 'locked' ? 'vui-pl-15' : '',
      inputProps: { 
        id: buildId, 
        value: buildId, 
        checked: item[key], 
        disabled: !permissionsId && item.locked,
        iconRight: key === 'locked' ? { name: 'lockOutline' } : undefined,
        color: key === 'locked' ? 'text' : color,
      } 
    }
  }

  Object.entries(permissions)
    .sort(([keyA, permissionA], [keyB, permissionB]) => {
      if (keyA === 'my_user' && keyB !== 'my_user') return -1
      if (keyB === 'my_user' && keyA !== 'my_user') return 1
      return (permissionA?.label || '').localeCompare(permissionB?.label || '')
    })
    .forEach(([key, permission]) => {
    let mapRows = []
    ;(permission?.items || [])
      .slice()
      .sort((itemA, itemB) => (itemA?.label || '').localeCompare(itemB?.label || ''))
      .forEach((item) => {
      mapRows.push({
        label: item.label,
        inputs: [
          { ...buildInput(item, 'system') },
          { ...buildInput(item, 'email') },
          ...(permissionsId ? [{ ...buildInput(item, 'locked') }] : []),
        ]
      })
    })
    mappedPermissions.push({
      id: key,
      headers: [
        { label: <span className='viso-notification-accordion__header'>{permission.label}</span> },
        { label: 'System', width: 70, hideOnCollapse: true },
        { label: 'Email', width: 70, hideOnCollapse: true },
        ...(permissionsId ? [{ label: 'Locked', width: 70, hideOnCollapse: true }] : []),
      ],
      rows: mapRows
    })
    })

  return mappedPermissions
}

export const mapNoticationPermissions = (permissions = {}, permissionsId, color = 'accent0') => {
  const getDomainLabel = (domain) => {
    if (domain === 'my_user') {
      return permissionsId ? 'User Tasks' : 'My Tasks'
    }
    return snakeCaseToTitleCase(domain.replaceAll('_', ' '))
  }

  const permissionsArray = Object.entries(permissions || {}).flatMap(([domain, actions]) =>
    Object.entries(actions || {}).map(([action, values]) => ({
      domain,
      action,
      ...values,
    }))
  )

  const mappedPermissions = permissionsArray.reduce((item, permission) => {
    const { domain } = permission
    if (!item[domain]) {
      item[domain] = {
        label: getDomainLabel(domain),
        items: []
      }
    }
    item[domain].items.push({ ...permission, label: snakeCaseToTitleCase(permission.action.replaceAll('_', ' ')) })
    return item
  }, {})
  return mapNotificationSettings(mappedPermissions, permissionsId, color)
}

export const updatePermissionValue = (id, value, permissions) => {
  const [domain, action, key] = id.split('---')

  if (!permissions?.[domain]?.[action]) {
    return permissions
  }

  return {
    ...permissions,
    [domain]: {
      ...permissions[domain],
      [action]: {
        ...permissions[domain][action],
        [key]: value,
      },
    },
  }
}